// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import Vue from 'vue'
import App from './App'
import router from './router'
import Vant from 'vant';
import 'vant/lib/index.css';
import { Notify } from 'vant';
import { Toast } from 'vant';
import { Dialog } from 'vant';
import 'vant/lib/index.less';
import 'vant/lib/icon/local.css';//本地
import './assets/css/icon.css';
import Header from '@/components/com/Header'
import { install as installI18n } from '@/locale/i18n'
Vue.config.productionTip = false
Vue.use(Vant)
installI18n(Vue)
Vue.component('Header',Header)
window.Notify = Notify
window.Toast = Toast
window.Dialog = Dialog
function gotoURL(callback){
  window.onpopstate = null;
  window.onpopstate = function(){
    callback()
  }
}
Vue.prototype.gotoURL = gotoURL
Vue.prototype.$VERSION_TYPE = 2; // 0-惠商通 1-E付通 2-SPAYPOS
Vue.prototype.$TITLE_NAME = this.$VERSION_TYPE===0?"惠商通":this.$VERSION_TYPE ==1?"E付通":"SPayPOS"; // 产品标题名称
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js